import React, { SVGProps } from "react";

const CartSimplified = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      className="icon icon--fill-cart"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.88276 10.4167C6.88654 10.4167 6.89032 10.4167 6.89411 10.4167H8.33331L15.8333 10.4167V12.0833H6.79077C5.24611 12.0833 3.93319 10.9548 3.70121 9.42764L2.65677 2.5519C2.57945 2.04285 2.14181 1.66667 1.62692 1.66667H0V0H1.62692C2.81286 0 3.86219 0.665235 4.3906 1.66535L5.66076 9.37004C5.69799 9.59589 5.79433 9.79923 5.93238 9.9653C6.1216 10.2401 6.43806 10.4167 6.79077 10.4167H6.88276ZM6.25 2.08333H16.875L14.5833 8.75H7.91667L7.29167 7.08333H13.3333L14.375 3.75H6.66667L6.25 2.08333ZM4.58333 15.4167C4.58333 14.7263 5.14298 14.1667 5.83333 14.1667H6.66667C7.35702 14.1667 7.91667 14.7263 7.91667 15.4167V16.25C7.91667 16.9404 7.35702 17.5 6.66667 17.5H5.83333C5.14298 17.5 4.58333 16.9404 4.58333 16.25V15.4167ZM12.9167 14.1667C12.2263 14.1667 11.6667 14.7263 11.6667 15.4167V16.25C11.6667 16.9404 12.2263 17.5 12.9167 17.5H13.75C14.4404 17.5 15 16.9404 15 16.25V15.4167C15 14.7263 14.4404 14.1667 13.75 14.1667H12.9167Z"
      />
    </svg>
  );
};

CartSimplified.displayName = "CartSimplified";

export default CartSimplified;
